<script>
import {GET_COMPLETED_MIDTERM_STUDENTS} from "@/core/services/store/course/classes.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

export default {
  name: "MidtermCompletedStudents",
  data(){
    return {
      listStudent: [],
      Status:{
        toDo: 1,
        done: 2
      }
    }
  },
  async mounted  () {
    await this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Chi tiết lớp học", route: 'schedule-class' },
      { title: "Chấm bài thi giữa khóa" }
    ]);
    await this.getMidtermCompletedStudent()
  },
  methods:{
    markMidtermTest(markingExamRetakeId,name){
       this.$router.push({name:'mark-midterm-test',params:{id:markingExamRetakeId},query:{classId:this.$route.params.id,name:name}})
    },
    viewMidtermTest(markingExamRetakeId,name){
      this.$router.push({name:'view-midterm-test-result',params:{id:markingExamRetakeId},query:{classId:this.$route.params.id,name:name}})
    },
    async getMidtermCompletedStudent (){
      let payload = {
        classroom_id: this.$route.params.id
      }
      try {
        const data = await this.$store.dispatch(GET_COMPLETED_MIDTERM_STUDENTS,payload)
        if(!data.error){
          this.listStudent = data?.data?.map((studentData)=>{
            return {
              name: studentData?.user_name,
              id: studentData?.user_id,
              phone: studentData?.user_phone,
              status: studentData?.status,
              markAt: studentData?.date_marking,
              markingExamRetakeId: studentData?.marking_exam_retake_id
            }
          })??[]
        }
      }catch (e) {

      }

    }
  }
}
</script>

<template>
<div class="p-5 " style="background-color: white ; border: 1px solid black">
  <p style="font-weight: bold ; font-size: 15px">
    Chấm bài thi giữa khóa
  </p>
  <div class="table-responsive" style="max-height: 700px; overflow-y: auto;">
    <table class="table table-bordered align-middle text-center">
      <thead class="table-light sticky-top" style="top: 0; z-index: 1;">
      <tr>
        <th>Họ và tên</th>
        <th>Mã học viên</th>
        <th>Số điện thoại</th>
        <th>Trạng thái</th>
        <th>Thời gian chấm bài</th>
        <th>Hành động</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="student in listStudent" :key="student.id">
        <td>{{student.name}}</td>
        <td>{{student.id + 100000}}</td>
        <td>{{student.phone}}</td>
        <td>
          <span v-if="student.status === Status.toDo" class="badge rounded-pill text-dark" style="background-color: orange;">Cần làm</span>
          <span v-if="student.status === Status.done" class="badge rounded-pill text-white" style="background-color: #20c997;">Hoàn thành</span>
        </td>
        <td>
          <p v-if="!student.markAt">—</p>
          <p v-else>{{student.markAt}}</p>
        </td>
        <td>
          <button v-if="student.status === Status.toDo" class="btn btn-xs btn-icon mr-2 btn-outline-info" style="color: orange;" @click="markMidtermTest(student.markingExamRetakeId,student.name)">
              <i class="fas fa-pen-nib"></i>
          </button>
          <button v-if="student.status === Status.done" class="btn btn-xs btn-icon btn-outline-primary" @click="viewMidtermTest(student.markingExamRetakeId,student.name)">
            <i class="fa fa-eye"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</div>
</template>

<style scoped>

</style>